import { Button } from "@fluentui/react-components";
import { ArrowRightRegular } from "@fluentui/react-icons";
import parse from "html-react-parser";
import { useAtomValue } from "jotai";
import { devices } from "library/constants";
import { ROUTES } from "library/routes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { selectedClientAtom } from "store";
import styled from "styled-components";

import { useAppTheme } from "hooks/useAppTheme";
import useEmployee from "hooks/useEmployee";

import LandingImage from "assets/landingPage.jpg";

export function HomePage() {
  const { employeeData } = useEmployee();

  const selectedClient = useAtomValue(selectedClientAtom);
  const navigate = useNavigate();
  const theme = useAppTheme();
  const html = selectedClient?.welcomePageText || ``;
  const { t } = useTranslation();

  const hasConsentGiven = employeeData?.isConsentGiven;

  const options = {
    replace({ attribs }) {
      if (!attribs) {
        return;
      }

      if (attribs.src) {
        return (
          <img
            src={attribs.src}
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
            alt="some-text"
          />
        );
      }
    },
  } as any;

  return (
    <Container>
      <Content className="ql-editor">
        {parse(html, options)}
        <Button
          onClick={() => {
            if (hasConsentGiven) {
              navigate(ROUTES.BENEFITS);
            } else {
              navigate(ROUTES.PROFILE);
            }
          }}
          iconPosition="after"
          style={{
            marginTop: "20px",

            background: theme.palette.purpleDark,
            color: theme.palette.white,
            maxWidth: "fit-content",
          }}
          icon={<ArrowRightRegular />}
        >
          {t("hbh.getStarted.label")}
        </Button>
      </Content>
      <LandingImg>
        <img
          src={selectedClient?.welcomePageImagePath || LandingImage}
          alt="homepage"
          width={"100%"}
        />
      </LandingImg>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: ${(props) => props.theme.palette.white};
  width: 100%;
  box-sizing: border-box;
  @media only screen and ${devices.md} {
    display: grid;

    grid-template-columns: 1fr 1fr;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 20px;
`;

const LandingImg = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 150px);
  img {
    object-fit: scale-down;
  }
`;
